/**
 * ElmerCat Block - View Script
 */

import { renderBlock } from "../script";
import metadata from "./block.json";

import Block from "./controller";

renderBlock(Block, metadata);

console.log("Juliete M. Belanger — " + document.currentScript.id);
